<template>
   <div class="mobile-input" ref="mobileInput">
    <div class="selectCountry" :style="{ width: selectCountryWidth }" v-if="Array.isArray(countryCodesDataToShow) && countryCodesDataToShow.length">
      <selectDropDown
        :options="countryCodesDataToShow"
        :isDisabled="false"
        popoverSize="auto"
        placeholder="Code"
        :clientSideSearch="true"
        @onSelectOption="val => {
          selectedCountryCode = val.selectedOption.dial_code;
          selectedCountryCodeOption = val.selectedOption;
        }"
        :selectedValueProp="selectedCountryCodeOption"
      />
    </div>
    <InputNumber slot="end" v-model="mobileNumber" :placeholder="placeholder" ariaLabel="mobile number" :maxlength="maxlength" :disabled="disabled" inputClass="sctn-input-currency" :style="{ width: mobileNumberWidth }" @onChange="checkMobile" > </InputNumber>
  </div>
</template>

<script>
import countryCodesData from '../resources/js/country-codes';
import InputNumber from "./inputNumber.vue";
import { removeNegativeSign } from '/src/helpers/measurement.helpers.js';
import selectDropDown from '/src/components/selectDropDown.vue';
import { useUIStore } from '@/stores/ui';

export default {
  components: { InputNumber, selectDropDown},
  emits:['update:mobile', 'update:countryCode', 'onChange'],
  props: {
    mobile: {
      type: String,
      default: '',
    },
    countryCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: String,
      default:'15'
    },
    placeholder: {
      type: String,
      default: 'Mobile Number',
    },
  },
  data() {
    return {
      countryCodesData,
      invalidMobile: false,
      selectCountryWidth: '20%', // default width
      mobileNumberWidth: '80%', // default width
      selectedCountryCodeOption: null
    }
  },
  mounted() {
    setTimeout(() => {
      this.updateWidths(); // Call the method after a small delay as Method is called before DOM rendered
      window.addEventListener('resize', this.updateWidths);
    }, 100);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWidths);
  },
  computed: {
    countryCodesDataToShow() {
      if (!this.countryCodesData) return [];
      return Object.entries(this.countryCodesData).map(([dialCode, data]) => ({
        ...data,
        title: `${ data.name } (${ data.dial_code })`,
        id: data.code,
        selectBoxValueToShow: `${dialCode} ${data.code}`,
        dialCodeKey: dialCode
      }));
    },
    selectedCountryCode: {
      get() {
        return this.countryCode;
      },
      set(value) {
        if (this.validateCountryCode(value)) {
          this.$emit('update:countryCode', value);
          this.$emit('onChange');
        }
      },
    },
    mobileNumber: {
      get() {
        return this.mobile;
      },
      set(value) {
        if (this.validateMobile(value)) {
          this.$emit('update:mobile', value);
          this.$emit('onChange');
        } else {
          this.$emit('update:mobile', this.mobile);
        }
      },
    },
  },
  watch: {
    selectedCountryCode: {
      handler() {
        this.updateSelectedCountryCodeOption()
      },
      immediate: true
    },
    countryCodesDataToShow: {
      handler() {
        this.updateSelectedCountryCodeOption()
      },
      immediate: true
    }
  },
  methods: {
    updateSelectedCountryCodeOption() {
      if (this.selectedCountryCode && Array.isArray(this.countryCodesDataToShow)) {
        this.selectedCountryCodeOption = this.countryCodesDataToShow.find(
          (item) => item.dialCodeKey === this.selectedCountryCode
        ) || null
      } else {
        this.selectedCountryCodeOption = null
      }
    },
    validateMobile(newValue) {
      newValue = removeNegativeSign(newValue);

      // Ensure it's only digits and within valid length
      const isValid = /^\d{6,15}$/.test(newValue);

      if (!isValid) {
        this.invalidMobile = true;
        return false;
      }

      this.invalidMobile = false;
      return true;
    },
    validateCountryCode(newvalue){
      if (!newvalue || newvalue == undefined || newvalue == ''){
        useUIStore().updateToast({ open: true, message: "Please select countrycode", type: "danger" });
        this.invalidMobile = true;
        return false;
      } else{
        this.invalidMobile = false;
        return true;
      } 
    },
    checkMobile() {
      if(this.invalidMobile) {
        useUIStore().updateToast({ open: true, message: "Please enter a valid mobile number", type: "danger" });
      }
    },
    updateWidths() {
      const mobileInput = this.$refs.mobileInput?.offsetWidth;
      if (mobileInput <= 768) {
        this.selectCountryWidth = '30%';
        this.mobileNumberWidth = '70%';
      } else {
        this.selectCountryWidth = '15%';
        this.mobileNumberWidth = '85%';
      }
    }
  }
};
</script>

<style scoped>
::v-deep(.select-drop-down-wrapper) {
  border-radius: 5px 0px 0px 5px;
  background: var(--gray-01);
  min-height: 40px;
  min-width: 106px;
}
.mobile-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
}

.pre-text {
  text-align: center;
  background: var(--purple-opac);
  color: var(--black);
  border: none;
  padding: 0px 10px;
  flex: 0 0 20%;
}
</style>